import React from "react";
import "./GetInTouch.scss";
import { InputCustom } from "../../Common/InputCustom/InputCustom";
import { ButtonCustom } from "../../Common/ButtonCustom/ButtonCustom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { message } from "antd";

function GetInTouch() {
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalid email format"
      ),
    business_name: Yup.string().required("Business Name is required"),
    message: Yup.string().required("Message is required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      business_name: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        const response = await fetch("https://stage.uniwalletpay.ai/api/v2/barong/public/contact/user", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values), // Send the form data
        });

        if (response.ok) {
          message.success("Contact Form Submitted Successfully")
          resetForm();
        }

      } catch (error) {
        message.error("There was an error submitting the form. Please try again later")
        console.error("Submission error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="getInTouch" id="contact">
      <h2>Get in Touch with Us</h2>
      <div className="getInTouch_inner container">
        <form onSubmit={formik.handleSubmit} className="getInputs">
          <div className="getInputs">
            <div className="getInputs_inputs">
              <div>
                <InputCustom
                  label="First Name"
                  id="first_name"
                  placeholder="Enter Your First Name"
                  name="first_name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // This is crucial!
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <p className="errorMsg">{formik.errors.first_name}</p>
                )}
              </div>
              <div>
                <InputCustom
                  label="Last Name"
                  placeholder="Enter Your Last Name"
                  name="last_name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <p className="errorMsg">{formik.errors.last_name}</p>
                )}
              </div>
            </div>
            <div className="getInputs_inputs">
              <div>
                <InputCustom
                  label="Email"
                  placeholder="Enter Your Email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="errorMsg">{formik.errors.email}</p>
                )}
              </div>
              <div>
                <InputCustom
                  label="Business Name"
                  placeholder="Enter Your Business Name"
                  name="business_name"
                  value={formik.values.business_name}
                  onChange={formik.handleChange}
                />
                {formik.touched.business_name && formik.errors.business_name && (
                  <p className="errorMsg">{formik.errors.business_name}</p>
                )}
              </div>
            </div>
            <div className="getInputs_inputs">
              <div>
                <InputCustom
                  label="Message"
                  isTextArea={true}
                  placeholder="Enter Your Message"
                  name="message"
                  value={formik.values.message}
                  onChange={formik.handleChange}
                />
                {formik.touched.message && formik.errors.message && (
                  <p className="errorMsg">{formik.errors.message}</p>
                )}
              </div>
            </div>
            <div className="getInputs_inputs">
              <ButtonCustom label="Send Message" htmlType="submit" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GetInTouch;
